import { id } from "date-fns/locale";
import { DataBean } from "../DataBean";

export class ContractFiles extends DataBean {

    public async updateContractFiles(bean: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.ContractFiles_updateContractFiles_com.orange.bean.ContractFiles", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.orange.bean.ContractFiles"
            }
        ]);
    }

    public async deleteContractFiles(idcontractfiles: number): Promise<any> {
        return this.getCustomService("FinanceCore", "boolean_deleteContractFiles_Number", [idcontractfiles]);
    }

    public async getContractFilesCatalogPorPropiedades(properties: any, maxRows: any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getContractFilesCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async getExpedientFilesRender(page: number, rows: number, properties: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getExpedientFilesRender_Number_Number_java.util.Map", [page, rows, properties]);
    }

}
